export default "__VITE_ASSET__Bdec62kg__"